<h2>Daten des Interessenten</h2>
<div class="mb">
  <h3>Anrede</h3>
  <mat-radio-group aria-label="Anrede" color="primary"
                   name="mainApplicant_salutation"
                   [formControl]="salutationFormControl">
    <mat-radio-button value="Herr">Herr</mat-radio-button>
    <mat-radio-button value="Frau">Frau</mat-radio-button>
  </mat-radio-group>
  <mat-error *ngIf="formSubmitAttempted && salutationFormControl.invalid">Bitte wählen Sie eine Anrede aus</mat-error>
</div>
<div class="grid-container-5-5-2">
  <mat-form-field appearance="fill" class="grid-element">
    <mat-label>Vorname</mat-label>
    <input name="mainApplicant_firstName" matInput [formControl]="firstNameFormControl"/>
    <mat-error *ngIf="firstNameFormControl.invalid">Bitte geben Sie einen Vornamen ein</mat-error>
  </mat-form-field>
  <mat-form-field appearance="fill" class="grid-element">
    <mat-label>Nachname</mat-label>
    <input name="mainApplicant_lastName" matInput [formControl]="lastNameFormControl"/>
    <mat-error *ngIf="lastNameFormControl.invalid">Bitte geben Sie einen Nachnamen ein</mat-error>
  </mat-form-field>
  <app-clearable-date-picker class="grid-element mobile-1-3" name="mainApplicant_birthday"
                             [formControl]="birthdayFormControl" label="Geburtsdatum">
  </app-clearable-date-picker>
  <mat-form-field appearance="fill" class="grid-element mobile-1-2">
    <mat-label>PLZ</mat-label>
    <input oninput="this.value = this.value.substr(0, 5)"
      name="mainApplicant_zipCode" type="tel" matInput [formControl]="zipCodeFormControl"/>
    <mat-error *ngIf="zipCodeFormControl.invalid">
      <span *ngIf="zipCodeFormControl.errors.required;else defaultError">Bitte geben Sie eine PLZ ein</span>
      <ng-template #defaultError>Bitte geben Sie eine 5-stellige PLZ ein</ng-template></mat-error>
  </mat-form-field>
  <mat-form-field appearance="fill" class="grid-element-2-4 grid-element mobile-2-3">
    <mat-label>Ort</mat-label>
    <input name="mainApplicant_city" matInput [formControl]="cityFormControl"/>
    <mat-error *ngIf="cityFormControl.invalid">Bitte geben Sie einen Ort ein</mat-error>
  </mat-form-field>
</div>
<div class="grid-container-1-1">
  <div class="mb">
    <h3>Präferierter Kontaktweg</h3>
    <mat-radio-group aria-label="Kontaktweg" color="primary"
                     name="mainApplicant_reachabilityComment" [formControl]="reachabilityFormControl">
      <mat-radio-button value="E-Mail">E-Mail</mat-radio-button>
      <mat-radio-button value="Telefon">Telefon</mat-radio-button>
    </mat-radio-group>
    <mat-error *ngIf="formSubmitAttempted && reachabilityFormControl.invalid">Bitte wählen Sie den präferierten Kontaktweg</mat-error>
  </div>
  <div><!--placeholder---></div>
  <mat-form-field appearance="fill">
    <mat-label>E-Mail</mat-label>
    <input name="mainApplicant_email" matInput [formControl]="emailFormControl"/>
    <mat-error *ngIf="emailFormControl.invalid">
      Bitte geben Sie eine gültige E-Mail Adresse ein</mat-error>
  </mat-form-field>
  <mat-form-field appearance="fill">
    <mat-label>Telefon</mat-label>
    <input name="mainApplicant_privatePhone" type="tel" matInput [formControl]="phoneFormControl"/>
    <mat-error *ngIf="phoneFormControl.invalid">Bitte geben Sie eine gültige Telefonnummer ein</mat-error>
  </mat-form-field>
</div>
